export const LOGIN_CONSTANTS = {
   staticToken: 'static-token',
   dynamicToken: 'dynamic-token',
   uid: 'uid',
   loggedInUser: 'aa-auk',
   authKey: 'FAMILY_PARENT_WEB_TOKEN_SHORTLIVED',
   groupId: 'ACQUISTION_POSTPAID_BUNDLING',
   coipGroupId: 'COIP_EMAIL_FLOW',
   priorityPostpaidGroupId: 'BUY_NON_P2P_ONE_AIRTEL'
};

export const CART_CONSTANTS = {
   DEFAULT_POSTPAID_PLAN: 'PKG_807',
   POSTPAID: 'POSTPAID',
   TELEMEDIA: 'TELEMEDIA',
   DTH: 'DTH',
   EN: 'EN',
   HN: 'HN',
   NN: 'NN',
   UNIQUE_ID: function () {
      return Math.floor(Math.random() * 1000000000).toString();
   },
   CHANNEL_SHOP: 'SHOP',
   PRODUCT_SEGMENT_CONSUMER: 'CONSUMER',
   PRODUCT_SEGMENT_RETAIL: 'RETAIL',
   PRODUCT_SUBTYPE_PRIMARY: 'PRIMARY',
   PRODUCT_SUBTYPE_HOME: 'HOME',
};

export const UTIL_CONSTANTS = {
    OTHER: "other"
}

export const CAMPAIGN_FOR_OTP_REMOVAL : any = {
   ps_pfx_postpaid_google : true
}

export const VARIANT_CONSTANTS = {
   PRIORITY_POSTPAID : "otp_at_end_priority_postpaid"
}

export const PUBLIC_KEY_URL =
   'https://assets.airtel.in/static-assets/airtel-lite/files/cert.pem';

const APP_ENVIRONMENT: any = {
   PRODUCTION: {
      baseUrl: 'https://digi-api.airtel.in/',
      environment: 'PRODUCTION',
   },
   PRODUCTION_V2: {
      baseUrl: 'https://digi-api.airtel.in/v2/',
      environment: 'PRODUCTION',
   },
   DEV_PLATFORM: {
      baseUrl: 'https://kongqa.airtel.com/acquisition-dev/',
      environment: 'STAGING',
   },
   INTERNAL_GUARDIAN: {
      baseUrl: 'https://kongqa.airtel.com/internal-guardian/',
      environment: 'STAGING',
   },
   QA_PLATFORM: {
      baseUrl: 'https://kongqa.airtel.com/web-test/',
      environment: 'STAGING',
   },
   WEB_PLATFORM: {
      baseUrl: 'https://kongqa.airtel.com/web/',
      environment: 'STAGING',
   },
   PORTFOLIO: {
      baseUrl: 'https://kongqa.airtel.com/acquisition/',
      environment: 'STAGING',
   },
   AUTOMATION: {
      baseUrl: 'https://kongqa.airtel.com/web-automation/',
      environment: 'STAGING',
   },
   PREPROD: {
      baseUrl: 'https://kongqa.airtel.com/preprod/',
      environment: 'PREPROD',
   },
};

export const getQueryString = () => {
   let queryString: any = (window && window.location && window.location.search) || '';
   let resultObj: any = {};
   queryString = queryString.substring(1);
   queryString = queryString.split('&');
   queryString.forEach((keyVal: any) => {
      let key = keyVal.substring(0, keyVal.indexOf('='));
      let value = keyVal.substring(keyVal.indexOf('=') + 1);
      resultObj[key] = value;
   });
   return resultObj;
};

export const BUTTON_THEME_CONFIG = {
   button: {
      light: {
         config: {
            primary: {
               controlState: {
                  none: {
                     buttonColor: '#CD2424',
                  },
                  disabled: {
                     buttonColor: '#A0A2A4',
                  },
                  hover: {
                     buttonColor: '#B22020',
                     borderColor: "#CD2424",
                     borderWidth: 1,
                  },
                  pressed: {
                     buttonColor: '#9D1C1C',
                  },
                  selected: {
                     buttonColor: '#075EE8',
                  },
               },
            },
         },
      },
   },
};

const getApiEnvConfig = () => {
   let config = APP_ENVIRONMENT.PRODUCTION_V2; // change for default config
   const { apiType, apiEnvType } = getQueryString();

   // to bypass api type
   if (apiType) config = APP_ENVIRONMENT[apiType];
   if (apiEnvType) config.environment = apiEnvType;

   return config;
};

export const API_CONFIGS = {
   appName: 'common_postpaid',
   ...getApiEnvConfig(),
};

export const ADD_DETAILS_INTENTS_MAPPING: Record<string, string> = {
   'port-to-airtel': 'mnp',
   'prepaid-to-postpaid': 'p2p',
   'new-sim': 'new-connection',
};

export const NP2P_PLANS_VARIANT = "cm_omni_with_plans";